import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

interface Props {
  field: string;
  label: string;
  /** The current sort, as `field:dir`. */
  sort: string;
  onSort: (sort: string) => void;
}

export function SortHeader({ field, label, sort, onSort }: Props) {
  const [activeField, direction] = sort.split(':');
  const isActive = activeField === field;
  const Icon = !isActive ? ArrowUpDown : direction === 'asc' ? ArrowUp : ArrowDown;
  return (
    <button
      type="button"
      onClick={() => onSort(`${field}:${isActive && direction === 'asc' ? 'desc' : 'asc'}`)}
      className="inline-flex items-center gap-1 font-semibold uppercase tracking-wider hover:opacity-80"
    >
      {label}
      <Icon className={`h-3 w-3 ${isActive ? '' : 'opacity-60'}`} />
    </button>
  );
}
